import { useEffect, useRef, useState } from "react";
import { productionGateway } from "../production-gateway";
import type { TerminalBootstrap } from "../models";

export type OperatorHandoverDialogProps = { context: TerminalBootstrap; onClose: () => void; onCompleted: () => Promise<void>; notify: (message: string, tone?: "success" | "error") => void };

export function useOperatorHandoverWorkspace({ context, onClose, onCompleted, notify }: OperatorHandoverDialogProps) {
  const inFlight = useRef(false);
  const candidates = context.assignments.filter((item) => item.operatorId !== context.session?.operatorId);
  const [operatorId, setOperatorId] = useState(candidates[0]?.operatorId ?? "");
  const [reason, setReason] = useState("BREAK");
  const [newPin, setNewPin] = useState("");
  const [supervisors, setSupervisors] = useState<Array<{ id: string; name: string }>>([]);
  const [supervisorId, setSupervisorId] = useState("");
  const [supervisorPin, setSupervisorPin] = useState("");
  const [saving, setSaving] = useState(false);
  const [checkingAssignments, setCheckingAssignments] = useState(false);
  const selectedOperator = candidates.find((item) => item.operatorId === operatorId);
  useEffect(() => {
    void productionGateway.terminalSupervisors(context.terminal.terminalCode)
      .then((items) => { setSupervisors(items); setSupervisorId(items[0]?.id ?? ""); })
      .catch((error) => notify(error instanceof Error ? error.message : "Vardiya amirleri alınamadı."));
  }, [context.terminal.terminalCode, notify]);
  const submit = async () => {
    const supervisor = supervisors.find((item) => item.id === supervisorId);
    if (inFlight.current || !operatorId || !supervisor || newPin.length !== 4 || supervisorPin.length !== 4) return;
    inFlight.current = true;
    setSaving(true);
    try {
      const approval = await productionGateway.approveTerminalAction(context.terminal.terminalCode, { supervisorId: supervisor.id, supervisorName: supervisor.name, pin: supervisorPin, actionScope: "OPERATOR_HANDOVER", targetRef: context.terminal.id });
      await productionGateway.handoverTerminal(context.terminal.terminalCode, { newOperatorId: operatorId, newOperatorPin: newPin, reason, approvalToken: approval.approvalToken });
      setNewPin(""); setSupervisorPin(""); notify("Operatör devri tamamlandı; açık sayaçlar kesintisiz devam ediyor."); await onCompleted(); onClose();
    } catch (error) { setNewPin(""); setSupervisorPin(""); notify(error instanceof Error ? error.message : "Operatör devri tamamlanamadı."); }
    finally { inFlight.current = false; setSaving(false); }
  };
  const checkAssignments = async () => {
    setCheckingAssignments(true);
    try {
      await onCompleted();
      notify("Vardiya atamaları yeniden kontrol edildi.");
      onClose();
    } catch (error) {
      notify(error instanceof Error ? error.message : "Vardiya atamaları kontrol edilemedi.");
    } finally {
      setCheckingAssignments(false);
    }
  };
  return { candidates, operatorId, setOperatorId, reason, setReason, newPin, setNewPin, supervisors, supervisorId, setSupervisorId, supervisorPin, setSupervisorPin, saving, checkingAssignments, selectedOperator, submit, checkAssignments };
}
